import { useState, useRef, useEffect } from 'preact/hooks'


export function useVisible(initial) {

	const ref = useRef()
    const [visible, setVisible] = useState(!!initial)
    
    const documentClickHandler = event => {
        if (ref.current && !ref.current.contains(event.target)) setVisible(false)
    }

    useEffect(() => {
        document.addEventListener('click', documentClickHandler, true)
        return () => document.removeEventListener('click', documentClickHandler, true)
    }, [])
    
    return { ref, visible, setVisible }
}